var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"min-width":"100%"}},[_vm._t("meta"),_c('div',{staticClass:"pa-0 ma-0",staticStyle:{"height":"0"},attrs:{"cols":"12","id":_vm.contentData.AnchorID}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }